import { type UUID } from '~/types/common';

import { type DeliveryNotePartySuggestionsQueryVariables } from '~/data/delivery/useQueryDeliveryNotePartySuggestions';

import { type DeliveryNoteFilterSuggestionsQueryParameters } from './useQueryDeliveryNoteFilterSuggestions';
import { type DeliveryNotesAdminQueryParameters } from './useQueryDeliveryNotesAdmin';

/**
 * Query key factory for delivery note-related queries.
 */
export const queryKeysDeliveryNote = {
  base: () => 'deliveryNote' as const,
  get: (deliveryNoteId: UUID) =>
    [queryKeysDeliveryNote.base(), 'detail', { deliveryNoteId }] as const,
  getAll: (searchParams: DeliveryNotesAdminQueryParameters) =>
    [queryKeysDeliveryNote.base(), 'list', searchParams] as const,
  getAttachment: ({
    deliveryNoteChainId,
    digest,
    name,
  }: {
    deliveryNoteChainId: UUID;
    digest?: string;
    name?: string;
  }) =>
    [
      queryKeysDeliveryNote.base(),
      'attachment',
      { deliveryNoteChainId, digest, name },
    ] as const,
  getByIds: (ids: UUID[]) =>
    [queryKeysDeliveryNote.base(), 'listByIds', { ids }] as const,
  getChains: (deliveryNoteChainIds: UUID[]) =>
    [queryKeysDeliveryNote.base(), 'chains', { deliveryNoteChainIds }] as const,
  getCount: (searchParams: DeliveryNotesAdminQueryParameters) =>
    [queryKeysDeliveryNote.base(), 'list', searchParams, 'count'] as const,
  getFilterSuggestions: (
    searchParams: DeliveryNoteFilterSuggestionsQueryParameters,
  ) =>
    [queryKeysDeliveryNote.base(), 'filterSuggestions', searchParams] as const,
  getLatestOriginalPdf: ({ assetId }: { assetId: UUID }) =>
    [queryKeysDeliveryNote.base(), 'latestOriginalPdf', { assetId }] as const,
  getPartySuggestions: (
    searchParams: DeliveryNotePartySuggestionsQueryVariables,
  ) =>
    [queryKeysDeliveryNote.base(), 'partySuggestions', searchParams] as const,
};
